import { render, staticRenderFns } from "./StandardView.vue?vue&type=template&id=2665ce9f&scoped=true"
import script from "./StandardView.vue?vue&type=script&lang=js"
export * from "./StandardView.vue?vue&type=script&lang=js"
import style0 from "./StandardView.vue?vue&type=style&index=0&id=2665ce9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665ce9f",
  null
  
)

export default component.exports